import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NZ_DATE_CONFIG, NZ_I18N, en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import it from '@angular/common/locales/it';
import en from '@angular/common/locales/en';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ThemeService } from './core/services/app/theme.service';
import { AppInitializerProvider } from './core/services/app/app-inizializer.service';
import { IconDefinition } from '@ant-design/icons-angular';
import { NZ_ICONS } from 'ng-zorro-antd/icon';
import * as AllIcons from '@ant-design/icons-angular/icons';
import { it_IT } from './core/config/i18n-ng-zorro/it_IT';
import { TranslationService } from './core/services/app/translation.service';
import { LayoutModule } from './layout/layout.module';
import { TranslateModule } from '@ngx-translate/core';
import { BaseComponent } from './pages/base/base.component';
import { LoaderService } from './core/services/app/loader.service';
import { LanguageService } from './core/services/app/language.service';
import { DevicesService } from './core/services/api/devices.service';
import { MonitoringService } from './core/services/api/monitoring.service';
import { UsersService } from './core/services/api/users.service';
import { VpnService } from './core/services/api/vpn.service';
import { HttpUtilsService } from './core/services/api/http-utils.service';
// Keycloak
import { KeycloakService, KeycloakAngularModule } from 'keycloak-angular';
import { KeycloakInitializer } from '../app/core/keycloak/keycloak-init';
import { SidebarConfigService } from './core/services/app/sidebar-config.service';
import { NgChartsModule } from 'ng2-charts';

registerLocaleData(it);
registerLocaleData(en);

const antDesignIcons = AllIcons as {
	[key: string]: IconDefinition;
};
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(key => antDesignIcons[key]);

@NgModule({
	declarations: [
		AppComponent,
		BaseComponent,
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		ReactiveFormsModule,
		FormsModule,
		HttpClientModule,
		BrowserAnimationsModule,
		KeycloakAngularModule,
		TranslateModule.forRoot(),
		LayoutModule,
  NgChartsModule
	],
	providers: [
		{
            provide: APP_INITIALIZER,
            useFactory: KeycloakInitializer,
            multi: true,
            deps: [KeycloakService]
        },
		{ provide: NZ_ICONS, useValue: icons },
		{ provide: NZ_DATE_CONFIG, useValue: { firstDayOfWeek: 1 } },
		{
			provide: NZ_I18N, useFactory: (localId: string) => {
				switch (localId) {
					case 'en':
						return en_US;
					case 'it':
						return it_IT;
					default:
						return en_US;
				}
			},
			deps: [LOCALE_ID]
		},
		ThemeService,
		AppInitializerProvider,
		TranslationService,
		SidebarConfigService,
		LoaderService,
		LanguageService,
		DevicesService,
		MonitoringService,
		UsersService,
		VpnService,
		HttpUtilsService,
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
